<template>
  <v-container class="grey darken-3 white--text text-xs-center">
    <v-flex>
      <v-btn
        id="location"
        @click="jumpToPage(icon)"
        v-for="icon in icons"
        :key="icon"
        class="mx-3 white--text"
        icon
      >
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
    </v-flex>
    <br />

    <v-layout row wrap>
      <v-flex>
        <v-card height="325px" class="elevation-24">
          <div class="pa-3">
            <v-img
              src="/static/greenfield-logo-1.png"
              alt="logo"
              height="170px"
            />
          </div>
          <v-card-text>
            <div v-text="$t('Views.Contact.phone')" class="mb-3" />
            <div v-text="$t('Views.Contact.address')" />
            <div v-text="$t('Views.Contact.cityState')" />
            <div v-text="$t('Views.Contact.zip')" />
          </v-card-text>
        </v-card>
        <br />
      </v-flex>
      <v-flex class="video-container">
        <iframe
          height="325"
          width="325"
          frameborder="0"
          style="border: 0;"
          src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJS1Hv6NpRrlQRl1KZceth_2w&key=AIzaSyAST2L88luHjJgcL0p1mEE3PHfJ2fetk10"
          allowfullscreen
        ></iframe>
      </v-flex>
      <br />
      <br />
      <v-flex>
        <v-card class="white--text grey darken-3" flat>
          <div id="hours">
            <br />
            <h2>Hours of Operation</h2>
            <br />
            <h3>Monday - Friday</h3>
            <h4>8:00 am - 5:00 pm</h4>
            <br />
            <h3>Sunday & Saturday</h3>
            <h4>Closed</h4>
            <br />
            <span class="color-red">
              We are also closed on New Years,
              <br />
              Memorial, Labor, Indepence,
              <br />
              Thanksgiving, and Christmas day.
            </span>
          </div>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="center white--text grey darken-3" flat>
          <div>
            <br />
            <br />
            <h2>Animal Drop Off Times</h2>
            <h2 style="color: red;">By Appointment Only</h2>
            <br />
            <h3>Thursday</h3>
            <h4>12:00 pm - 4:00 pm</h4>
            <br />
          </div>
        </v-card>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-card-text class="white--text text-xs-center">
      &copy;2019 — <strong>Wayguud Custom Meats, LLC.</strong>
    </v-card-text>
  </v-container>
</template>

<script>
export default {
 data: () => ({
  icons: ['fab fa-facebook', 'fab fa-google', 'fas fa-phone'],
  column: false,
 }),
 methods: {
  window() {
   if (window.screen.availWidth < 500) {
    return true
   } else {
    return 'hello'
   }
  },
  jumpToPage(icon) {
   if (icon == 'fab fa-google') {
    window.open(
     'https://www.google.com/search?source=hp&ei=ZRHbW92UNeOy0PEPjviV-Ak&q=greenfield+custom+meat+meridian+id&btnK=Google+Search&oq=greenfield+custom+meat+meridian+id&gs_l=psy-ab.3..0j38.8031.15699..15892...1.0..0.77.2363.35......0....1..gws-wiz.......0i131j0i22i30.SNiuiuiLhVI'
    )
   } else if (icon == 'fab fa-facebook') {
    window.open('https://facebook.com/GreenfieldCustomMeats/')
   } else if (icon == 'fas fa-phone') {
    window.open('tel:+1-208-888-9690')
   }
  },
 },
}
</script>

<style>
th {
 text-align: right;
}
td {
 text-align: left;
}
</style>
